/*
CHAT: https://chatgpt.com/c/699927c7-d804-832b-b13a-04f97c9597b5

AI UPDATE PROMPT 
=========================================================================================  START ==========
Using the same style, create the following pages as reactset components for LiveAgent365.com: 
- Privacy Policy
- Terms & Conditions / Terms of Service
- SMS Terms / Messaging Policy (can be a section inside Terms, but must be explicit)
- Contact (with business name + email + phone + address)

Also, make the request a demo form a seperate component and A2P compliant. 

Make a typescript content object and organized each secion/row on landing page so the content is easy to read and update. 

For example: 
- Section1: Pitch
  - Never miss a call  Capture every lead 24/7 Master your reputation management
    content...
- Section2: Features and Benefits
    - Everything you want a phone agent to do—without the missed calls
      content...
- Section3: How it works\
     content...
- Section4: Ideal customer
  - Built for teams that live on inbound calls
     content...
- Section5: Pricing
  - Simple pricing
     content...
- Section6: FAQ
  - FAQ items
     content...
- Section7: Book a Demo
  - Request a demo
     content...


Next Update the landing page code with a global header and footer component along with the links to the various pages. 

Call this v02 

Here is the Laning page code for VoiceAgent 365:

=========================================================================================  PROMPT END ==========

*/

// -------------------------------------------------------------------------------------------------------------
// CODE TO BE UPDATE
// -------------------------------------------------------------------------------------------------------------
import React, { useMemo, useState, ReactNode } from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  Button,
  Card,
  Badge,
  Form,
  InputGroup,
  Accordion,
  Alert,
  ListGroup,
  Carousel,
} from "react-bootstrap";
import {
  TelephoneInbound,
  Headset,
  Mic,
  ShieldCheck,
  Clock,
  LightningCharge,
  GraphUpArrow,
  Envelope,
  CheckCircleFill,
  StarFill,
  RocketTakeoff,
  Building,
  People,
  Gear,
  Telephone,
} from "react-bootstrap-icons";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LiveAgent365Header } from "./LiveAgent365Header_v03";
import ContactPage_v03a from "./LiveAgent365_v02_ContactPage_v03a";
// import { MASTER_CONFIG_OPTIONS } from "../../../../00MasterConfig/MasterSystemConfig";
import { MASTER_CONFIG_OPTIONS } from "../../../00MasterConfig/MasterSystemConfig";



type LeadFormState = {
  fullName: string;
  email: string;
  phone: string;
  company: string;
  website: string;

  primaryObjectives: string[]; // checkboxes
  callVolume: string;
  notes: string;
  smsConsent: boolean;
  smsMarketingConsent: boolean;
  smsNonMarketingConsent: boolean;
};


const VERSION = "v02.0.0";
const API_URL = MASTER_CONFIG_OPTIONS.API_URL;


type WirePayload = Record<string, string>;

type VoiceAgentLeadPayload = {
  // Landing page fields
  fullName: string;
  email: string;
  phone: string;
  company: string;
  website: string;
  primaryObjectives: string[];
  callVolume: string;
  notes: string;

  smsConsent: boolean;
  smsConsentText: string;
  smsConsentSource: string;
// Metadata
  domainName: string;
  itemCategory: string;
  itemClass: string;
  itemType: string;
  clientVersion: string;
};

const PRIMARY_OBJECTIVE_OPTIONS = [
  "Missed calls & lead capture",
  "After-hours answering",
  "Appointment requests / Setting",
  "Sales qualification",
  "Routing & support triage",
];

const toggleInArray = (arr: string[], value: string) =>
  arr.includes(value) ? arr.filter((x) => x !== value) : [...arr, value];

const digitsOnly = (s: string) => (s || "").replace(/\D/g, "");

function toWirePayloadStrings(p: VoiceAgentLeadPayload): WirePayload {
  const out: WirePayload = {};
  for (const [k, v] of Object.entries(p)) {
    if (typeof v === "string") out[k] = v;
    else if (typeof v === "number") out[k] = Number.isFinite(v) ? `${v}` : "";
    else if (typeof v === "boolean") out[k] = v ? "true" : "false";
    else if (v && typeof v === "object") {
      try {
        out[k] = JSON.stringify(v);
      } catch {
        out[k] = "";
      }
    } else out[k] = "";
  }
  return out;
}

async function postLead(
  payload: WirePayload
): Promise<{ ok: boolean; status: number; id?: string; message?: string }> {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
    mode: "cors",
  });

  let resJson: unknown = null;
  try {
    const txt = await res.text();
    resJson = txt ? JSON.parse(txt) : null;
  } catch {
    resJson = null;
  }

  const asObj = (x: unknown): Record<string, unknown> | null =>
    x && typeof x === "object" && !Array.isArray(x)
      ? (x as Record<string, unknown>)
      : null;

  if (!res.ok) {
    const o = asObj(resJson);
    const msg =
      (o?.error as string) ||
      (o?.message as string) ||
      `Request failed: ${res.status}`;
    return { ok: false, status: res.status, message: msg };
  }

  const o = asObj(resJson);
  const id = (o?.id as string) || (o?.requestId as string) || undefined;
  return { ok: true, status: res.status, id };
}


//HOME PAGE INFO
interface IBrand{
  name: ReactNode,
  tagline: ReactNode
}
const brand:IBrand = {
  name: "LiveAgent365",
  tagline: <>Never miss a call 24/7<br></br>
  * Capture every lead<br></br>
  * Route Calls<br></br>
  * Book appointments<br></br>
  * Respond to Customers<br></br>
  * Master your reputation &nbsp;&nbsp;&nbsp;management<br></br>
  * AI Automation Services</>,
};

const CONTACT_PHONE_DISPLAY = "(888) 230-1882";
const CONTACT_PHONE_TEL = "+18882301882";



const sectionId = {
  top: "top",
  features: "features",
  how: "how",
  useCases: "usecases",
  pricing: "pricing",
  faq: "faq",
  contact: "contact",
};

type CarouselImage = {
  id: string;
  label: ReactNode;
  caption: ReactNode;
  src: string;
  alt: string;
};

const HERO_CAROUSEL: CarouselImage[] = [
  {
    id: "call-center",
    label: <>24/7 Answering</>,
    caption: <>Customers get a friendly response any time—day or night.</>,
    src: "/LiveAgent365-images/AdobeStock_1681370151_CallCenter.jpg",
    alt: "Phone support team",
  },
  {
    id: "lead-capture",
    label: <>Lead Capture</>,
    caption: <>Name, phone, email, and reason—captured cleanly and sent to your team.</>,
    src: "/LiveAgent365-images/AdobeStock_630606028_Team.jpg",
    alt: "Person using a phone and laptop",
  },
  {
    id: "appointments",
    label: <>Appointment Requests / Setting</>,
    caption: <>Collect preferred times and keep your schedule moving.</>,
    src: "/LiveAgent365-images/AdobeStock_1193038361_SalesTeam.jpg",
    alt: "Calendar and planning concept",
  },
  {
    id: "insights",
    label: <>Insights & Improvements</>,
    caption: <>Learn what callers ask for and tune scripts to convert more leads.</>,
    src: "/LiveAgent365-images/AdobeStock_1783238939_Innovation.jpg",
    alt: "Analytics dashboard concept",
  },
];

type HeroCarouselTheme = {
  label: string;
  overlayBg: string;
  titleColor: string;
  captionColor: string;
};

type ContactSubCardTheme = {
  label: ReactNode;
  cardBackground: string;
  titleColor: string;
  bodyColor: string;
  iconBg: string;
};

type SectionTheme = {
  label: string;
  background: string;
  textColor?: string;
  mutedTextColor?: string;
  borderTop?: string;
  boxShadow?: string;
  contactSubCards?: ContactSubCardTheme;
  heroCarousel?: HeroCarouselTheme;
};

const SECTION_THEMES: Record<
  "hero" | "features" | "how" | "useCases" | "pricing" | "faq" | "contact",
  SectionTheme
> = {
  hero: {
    label: "Hero (brand gradient)",
    background:
      "linear-gradient(180deg, #0d6efd 0%, #3d8bfd 48%, #f8f9fa 100%)",
    textColor: "#ffffff",
    mutedTextColor: "rgba(255,255,255,.78)",
    heroCarousel: {
      label: "Hero Carousel Overlay",
      overlayBg: "rgba(0,0,0,.55)",
      titleColor: "#ffffff",
      captionColor: "rgba(255,255,255,.82)",
    },
  },
  features: {
    label: "Features (clean white)",
    background: "#d5d9deff",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.70)",
    borderTop: "1px solid rgba(0,0,0,.06)",
  },
  how: {
    label: "How it works (blue tint)",
    background:
      "linear-gradient(180deg, rgba(9, 100, 237, 0.6), rgba(13,110,253,.04))",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.72)",
    borderTop: "1px solid rgba(0,0,0,.08)",
    boxShadow: "inset 0 1px 0 rgba(0,0,0,.10)",
  },
  useCases: {
    label: "Use cases (soft gray)",
    background: "#d5d9deff",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.70)",
    borderTop: "1px solid rgba(0,0,0,.08)",
    boxShadow: "inset 0 1px 0 rgba(0,0,0,.08)",
  },
  pricing: {
    label: "Pricing (white, decision area)",
    background:
      "linear-gradient(180deg, rgba(9, 100, 237, 0.6), rgba(13,110,253,.04))",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.70)",
    borderTop: "1px solid rgba(0,0,0,.08)",
  },
  faq: {
    label: "FAQ (tint)",
    background: "#d5d9deff",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.72)",
    borderTop: "1px solid rgba(0,0,0,.08)",
    boxShadow: "inset 0 1px 0 rgba(0,0,0,.10)",
  },
  contact: {
    label: "Contact (blue tint CTA)",
    background:
      "linear-gradient(180deg, rgba(9, 100, 237, 0.6), rgba(13,110,253,.04))",
    textColor: "#212529",
    mutedTextColor: "rgba(33,37,41,.72)",
    borderTop: "1px solid rgba(0,0,0,.16)",
    contactSubCards: {
      label: "Contact Sub-Cards",
      cardBackground: "rgba(255,255,255,.72)",
      titleColor: "#212529",
      bodyColor: "rgba(33,37,41,.70)",
      iconBg: "rgba(13,110,253,.14)",
    },
  },
};

const DIVIDER_BAND = {
  heightPx: 14,
  background: "linear-gradient(90deg, rgba(0,0,0,.10), rgba(0,0,0,0))",
};

const getStickyNavOffset = () => {
  const navEl =
    (document.querySelector("nav.navbar") as HTMLElement | null) ||
    (document.querySelector("[data-sticky-nav='true']") as HTMLElement | null);

  const navH = navEl?.offsetHeight ?? 72;
  const extraGap = 16;
  return navH + extraGap;
};


type PageContent = {
  hero: {
    title: ReactNode;
    subtitle: ReactNode;
    primaryCta: { text: ReactNode; onClickTargetId: string };
    secondaryCta: { text: ReactNode; onClickTargetId: string };
    carousel: CarouselImage[];
  };
  features: {
    title: ReactNode;
    subtitle: ReactNode;
    cards: Array<{ title: ReactNode; desc: ReactNode; badge: ReactNode }>;
  };
  how: {
    title: ReactNode;
    subtitle: ReactNode;
    steps: Array<{ title: ReactNode; desc: ReactNode }>;
  };
  useCase: {
    title: ReactNode;
    subtitle: ReactNode;
    cards: Array<{ title: ReactNode; desc: ReactNode }>;
  };
  pricing: {
    title: ReactNode;
    subtitle: ReactNode;
    callout: ReactNode;
    tiers: Array<{
      name: string;
      price: string;
      subtitle: ReactNode;
      bullets: ReactNode[];
      ctaText: string;
      highlight?: boolean;
    }>;
  };
  faq: {
    title: ReactNode;
    subtitle: ReactNode;
    items: Array<{ q: ReactNode; a: ReactNode }>;
  };
  contact: {
    title: ReactNode;
    subtitle: ReactNode;
    rightTitle: ReactNode;
    rightBody: ReactNode;
    subCards: Array<{ title: ReactNode; desc: ReactNode }>;
  };
};

const PAGE_CONTENT: PageContent = {
  hero: {
    title: (
      <>
        Never miss a call. <span className="text-warning">Capture every lead</span> 24/7.
      </>
    ),
    subtitle: (
      <>
        LiveAgent365 answers, qualifies, and summarizes inbound calls so your team follows up fast.
        <br />
        Sound natural. Capture accurate details. Improve over time.
      </>
    ),
    primaryCta: { text: <>Request a demo</>, onClickTargetId: sectionId.contact },
    secondaryCta: { text: <>See feature highlights</>, onClickTargetId: sectionId.features },
    carousel: HERO_CAROUSEL,
  },

  features: {
    title: <>Everything you want a phone agent to do—without the missed calls</>,
    subtitle: (
      <>
        LiveAgent365 is designed to sound natural, collect accurate info, and send clean summaries so you can follow up
        quickly.
      </>
    ),
    cards: [
      { title: <>Natural voice conversations</>, desc: <>A calm, consistent speaking pace that sounds human—great for customer trust.</>, badge: <>Core</> },
      { title: <>Missed-call capture</>, desc: <>Collects name, phone, email, and reason for calling—even when you’re busy.</>, badge: <>24/7</> },
      { title: <>Appointment requests</>, desc: <>Captures preferred times, confirms details, and alerts your staff for follow-up.</>, badge: <>Scheduling</> },
      { title: <>Instant summaries</>, desc: <>Sends a clean internal notification with contact info + request summary.</>, badge: <>Zero-friction</> },
      { title: <>Privacy-first handling</>, desc: <>Designed to collect only what you need and keep the recap simple and usable.</>, badge: <>Trust</> },
      { title: <>Performance visibility</>, desc: <>Track lead capture, call reasons, and outcomes to improve scripts over time.</>, badge: <>Analytics</> },
    ],
  },

  how: {
    title: <>How it works</>,
    subtitle: <>Setup is simple. Start with a script, route notifications, then go live.</>,
    steps: [
      {
        title: <>Choose your script</>,
        desc: (
          <>
            Start with a proven intake script (what callers ask for, the info you need, and your hours). We’ll tailor it to
            your business.
          </>
        ),
      },
      {
        title: <>Connect your handoff</>,
        desc: (
          <>
            Route summaries to the right place—SMS/email to your team, a shared inbox, or your CRM—so every lead gets a fast
            follow-up.
          </>
        ),
      },
      {
        title: <>Go live &amp; improve</>,
        desc: (
          <>
            Launch in days. Review real call recaps, update FAQs, and refine the script to capture better details and book
            more appointments.
          </>
        ),
      },
    ],
  },

  useCase: {
    title: <>Built for teams that live on inbound calls</>,
    subtitle: (
      <>
        Perfect for service businesses where missed calls mean missed revenue—capture every opportunity and follow up fast.
      </>
    ),
    cards: [
      {
        title: <>Local services</>,
        desc: <>Plumbers, electricians, HVAC, roofing, landscaping, junk removal—capture leads when the phone rings.</>,
      },
      {
        title: <>Appointment-based</>,
        desc: <>Clinics, salons, trainers, and consultants—collect the right details and route for easy scheduling.</>,
      },
      {
        title: <>High-volume inbound</>,
        desc: <>Busy offices and call-heavy teams—reduce repeat calls and speed up response with clean summaries.</>,
      },
      {
        title: <>After-hours <b>24/7 </b>coverage</>,
        desc: <>Nights, weekends, and lunch breaks—keep converting even when your team is offline.</>,
      },
       {
        title: <>Real Estate </>,
        desc: <>Agents, brokers, and property managers—capture buyer, seller, renter, and investor leads 24/7, qualify intent, route showing requests, follow up fast and keep deals moving even after hours.</>,

      },
    ],
  },

  pricing: {
    title: <>Simple pricing</>,
    subtitle: <>Start small and scale up when your call volume grows.</>,
    callout: <>Plans shown are typical starting points. Most teams get ROI from just a handful of recovered calls each month.</>,
    tiers: [
      {
        name: "Starter",
        price: "$99",
        subtitle: <>For low-volume call capture</>,
        bullets: [
          <>24/7 missed-call capture</>,
          <>Name + phone + email collection</>,
          <>Call summary via email</>,
          <>Basic script customization</>,
        ],
        ctaText: "Talk to sales",
      },
      {
        name: "Growth",
        price: "$249",
        subtitle: <>For steady inbound volume</>,
        bullets: [
          <>Everything in Starter</>,
          <>Deeper script customization</>,
          <>Routing options + escalation patterns</>,
          <>Faster iteration support</>,
        ],
        ctaText: "Request a demo",
        highlight: true,
      },
      {
        name: "Pro",
        price: "$499",
        subtitle: <>For higher volume + advanced workflows</>,
        bullets: [
          <>Everything in Growth</>,
          <>Advanced routing / multiple teams</>,
          <>Enhanced summaries &amp; reporting</>,
          <>Priority support</>,
        ],
        ctaText: "Request a demo",
      },
    ],
  },

  faq: {
    title: <>FAQ</>,
    subtitle: <>Quick answers to the most common setup questions.</>,
    items: [
      {
        q: <>Do callers need an account?</>,
        a: <>No. LiveAgent365 can collect an email for follow-up without requiring a full account signup.</>,
      },
      {
        q: <>Can it schedule appointments?</>,
        a: <>It can collect preferred dates/times and details, then notify your team to confirm and book.</>,
      },
      {
        q: <>How do we get the lead info?</>,
        a: <>You’ll receive an email summary (and optional routing) with the caller’s details and request.</>,
      },
      {
        q: <>How long does setup take?</>,
        a: <>Most teams can go live quickly with a proven script and refine after seeing real call patterns.</>,
      },
      {
        q: <>What kinds of businesses fit best?</>,
        a: <>Any business with inbound calls—especially local services and appointment-driven teams.</>,
      },
      {
        q: <>Is this A2P / messaging compliant?</>,
        a: <>Yes—our website demo form includes explicit SMS consent and a clear messaging policy on the Terms page.</>,
      },
      {
        q: <>Can we customize the script?</>,
        a: <>Absolutely. We start with a proven baseline and tailor questions, tone, and routing to your workflow.</>,
      },
    ],
  },

  contact: {
    title: <>Request a quote</>,
    subtitle: (
      <>
        Tell us what you need and we’ll map your current process into a simple AI + human handoff flow—so your team gets
        clean summaries and converts more leads.
      </>
    ),
    rightTitle: <>Start getting results today</>,
    rightBody: (
      <>
        Request a quote and we’ll map your current process (who handles calls/messages today) into a simple AI + human
        handoff flow—with clean summaries your team can act on immediately.
      </>
    ),
    subCards: [
      { title: <>Fast to launch</>, desc: <>Start with a proven script and refine based on real calls.</> },
      { title: <>Reliable capture</>, desc: <>Name + phone + email + reason captured in a clean recap.</> },
      { title: <>Improve over time</>, desc: <>Track what callers ask for and tune the script to convert more leads.</> },
      { title: <>Human handoff</>, desc: <>Your team gets a summary and follows up—simple and effective.</> },
    ],
  },
};

const scrollToId = (id: string) => {
  const el = document.getElementById(id);
  if (!el) return;

  const y =
    el.getBoundingClientRect().top + window.scrollY - getStickyNavOffset();
  window.scrollTo({ top: y, behavior: "smooth" });
};

const DividerBand: React.FC = () => (
  <div aria-hidden style={{ height: DIVIDER_BAND.heightPx, background: DIVIDER_BAND.background }} />
);

const Section: React.FC<{
  id: string;
  themeKey: keyof typeof SECTION_THEMES;
  className?: string;
  children: React.ReactNode;
}> = ({ id, themeKey, className, children }) => {
  const theme = SECTION_THEMES[themeKey];
  const scrollMarginTop = `${getStickyNavOffset()}px`;

  return (
    <section
      id={id}
      className={`py-5 position-relative ${className ?? ""}`}
      style={{
        background: theme.background,
        color: theme.textColor,
        borderTop: theme.borderTop,
        boxShadow: theme.boxShadow,
      }}
    >
      <div style={{ scrollMarginTop }}>{children}</div>
    </section>
  );
};

const FeatureCard: React.FC<{
  icon: ReactNode;
  title: ReactNode;
  desc: ReactNode;
  badge?: ReactNode;
}> = ({ icon, title, desc, badge }) => (
  <Card className="h-100 shadow-sm border-0 rounded-4">
    <Card.Body className="p-4">
      <div className="d-flex align-items-start gap-3">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-4"
          style={{
            width: 44,
            height: 44,
            background: "rgba(13,110,253,.12)",
          }}
        >
          <div style={{ fontSize: 20 }}>{icon}</div>
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <Card.Title className="mb-0">{title}</Card.Title>
            {badge ? (
              <Badge bg="primary" className="rounded-pill">
                {badge}
              </Badge>
            ) : null}
          </div>
          <Card.Text className="text-muted mt-2 mb-0">{desc}</Card.Text>
        </div>
      </div>
    </Card.Body>
  </Card>
);

const ContactSubCard: React.FC<{
  icon: React.ReactNode;
  title: ReactNode;
  desc: ReactNode;
  theme: ContactSubCardTheme;
}> = ({ icon, title, desc, theme }) => (
  <Card className="h-100 shadow-sm border-0 rounded-4" style={{ background: theme.cardBackground }}>
    <Card.Body className="p-4">
      <div className="d-flex align-items-center gap-2 mb-2">
        <span
          className="d-inline-flex align-items-center justify-content-center rounded-4"
          style={{ width: 36, height: 36, background: theme.iconBg }}
        >
          {icon}
        </span>
        <h6 className="mb-0" style={{ color: theme.titleColor }}>
          {title}
        </h6>
      </div>
      <div style={{ color: theme.bodyColor }}>{desc}</div>
    </Card.Body>
  </Card>
);

const PriceCard: React.FC<{
  name: string;
  price: string;
  subtitle: ReactNode;
  bullets: ReactNode[];
  ctaText: string;
  highlight?: boolean;
}> = ({ name, price, subtitle, bullets, ctaText, highlight }) => (
  <Card
    className={`h-100 shadow-sm border-0 rounded-4 ${highlight ? "border border-2" : ""}`}
    style={highlight ? { borderColor: "rgba(13,110,253,.45)" } : { borderColor: "transparent" }}
  >
    <Card.Body className="p-4">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h5 className="mb-1">{name}</h5>
          <div className="text-muted">{subtitle}</div>
        </div>
        {highlight ? (
          <Badge bg="primary" className="rounded-pill">
            Most Popular
          </Badge>
        ) : null}
      </div>

      <div className="my-3">
        <span className="display-6 fw-bold">{price}</span>
        <span className="text-muted ms-2">/mo</span>
      </div>

      <ListGroup variant="flush" className="mb-3">
        {bullets.map((b, i) => (
          <ListGroup.Item key={i} className="px-0 bg-transparent">
            <span className="me-2 text-success">
              <CheckCircleFill />
            </span>
            {b}
          </ListGroup.Item>
        ))}
      </ListGroup>

      <Button
        variant={highlight ? "primary" : "outline-primary"}
        className="w-100 rounded-pill"
        onClick={() => scrollToId(sectionId.contact)}
      >
        {ctaText}
      </Button>
    </Card.Body>
  </Card>
);

const HeroCarousel: React.FC = () => {
  const theme = SECTION_THEMES.hero.heroCarousel ?? {
    label: "Hero Carousel Overlay",
    overlayBg: "rgba(0,0,0,.55)",
    titleColor: "#fff",
    captionColor: "rgba(255,255,255,.85)",
  };

  return (
    <Card className="shadow border-0 rounded-4 overflow-hidden">
      <Carousel interval={4500} controls indicators touch pause="hover">
        {PAGE_CONTENT.hero.carousel.map((img) => (
          <Carousel.Item key={img.id}>
            <div style={{ position: "relative" }}>
              <img
                src={img.src}
                alt={img.alt}
                style={{ width: "100%", height: 320, objectFit: "cover", display: "block" }}
              />
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 0,
                //   padding: "14px 16px",
                 padding: "14px 16px 40px",  // top/left-right + EXTRA bottom padding
                  background: theme.overlayBg,
                }}
              >
                <div className="fw-semibold" style={{ color: theme.titleColor }}>
                  {img.label}
                </div>
                <div style={{ color: theme.captionColor }}>{img.caption}</div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </Card>
  );
};

const LabelValue: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="mb-2">
    <div className="text-muted small">{label}</div>
    <div className="fw-semibold">{value}</div>
  </div>
);

//Ed 
// -- --
// -- Both Cars 
// -- Full replacement cost 
// -- 

const PhoneLink: React.FC<{ variant?: "light" | "dark" }> = ({ variant = "dark" }) => (
  <a
    href={`tel:${CONTACT_PHONE_TEL}`}
    className={`text-decoration-none fw-semibold ${
      variant === "light" ? "text-white" : "text-dark"
    }`}
  >
    {CONTACT_PHONE_DISPLAY}
  </a>
);





// -------------------------------------------------------------------------------------------------------------
// v02 COMPONENTS: Global Header / Footer + Demo Form Panel (A2P) + Policy Pages
// -------------------------------------------------------------------------------------------------------------

type HeaderNavItem = { id: string; label: string };

const LANDING_NAV_ITEMS: HeaderNavItem[] = [
  { id: sectionId.features, label: "Features" },
  { id: sectionId.how, label: "How it works" },
  { id: sectionId.useCases, label: "Use cases" },
  { id: sectionId.pricing, label: "Pricing" },
  { id: sectionId.faq, label: "FAQ" },
  { id: sectionId.contact, label: "Request a demo" },
];









const LiveAgent365Footer_v02: React.FC<{
  brandName: string;
  version: string;
}> = ({ brandName, version }) => {
  return (
    <div className="mt-5 pt-4 border-top">
      <Row className="g-3 align-items-center">
        
        {/* LEFT */}
        <Col md={4} className="text-md-start text-center">
          <div className="fw-semibold">{brandName}</div>
          <div className="small text-muted">
            AI Automation Services & Reputation management
          </div>
        </Col>


        {/* CENTER */}
        
        <Col md={4} className="text-md-end text-center">
          <br></br>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a className="text-decoration-none" href="/">
              Home
            </a>
            <a className="text-decoration-none" href="/privacy">
              Privacy
            </a>
            <a className="text-decoration-none" href="/terms">
              Terms
            </a>
            <a className="text-decoration-none" href="/contact">
              Contact
            </a>
          </div>
        </Col>


        {/* RIGHT */}
        <Col md={4} className="text-center">
          <br></br>

          <div className="small text-muted">
            © {new Date().getFullYear()} {brandName}. All rights reserved. {version}
          </div>
        </Col>

     

      </Row>
    </div>
  );
};







let SMS_CONSENT_TEXT: ReactNode = <>By checking the box, you agree to receive SMS text messages from LiveAgent365. Msg & data rates may apply. Msg frequency varies. Reply STOP to opt out; HELP for help. Consent is not a condition of purchase.  This language is required by law. <br></br> <b><i>We will not sell your data, bother you or spam you.</i></b></>

const RequestDemoPanel_v02_A2P: React.FC<{
  form: LeadFormState;
  submitting: boolean;
  submitError: string | null;
  submitOk: boolean;
  lastSubmitted: VoiceAgentLeadPayload | null;
  serverStatus: { ok: boolean; status: number; id?: string; message?: string } | null;
  onChange: (k: keyof LeadFormState, v: string | boolean) => void;
  onSubmit: (e: React.FormEvent) => void;
  onReset: () => void;
}> = (props) => {
  const showWarn = props.serverStatus && !props.serverStatus.ok;
  const smsConsentMissing = Boolean(props.submitError && /sms\s*consent/i.test(props.submitError));
  return props.submitOk && props.lastSubmitted ? (
    <Card className="shadow-sm border-0 rounded-4">
      <Card.Body className="p-4">
        <Alert variant="success" className="rounded-4">
          <div className="d-flex align-items-start gap-2">
            <CheckCircleFill className={`mt-1 ${smsConsentMissing ? "bg-warning bg-opacity-25 border border-warning rounded-3 p-2" : ""}`} />
            <div>
              <div className="fw-semibold">Thank you — we received your request!</div>
              <div className="text-muted">A representative will be following up shortly.</div>
            </div>
          </div>
        </Alert>

        <div className="small text-muted">
          <div className="mb-2">
            <span className="fw-semibold text-dark">Submitted:</span>{" "}
            {props.lastSubmitted.fullName} • {props.lastSubmitted.email} • {props.lastSubmitted.phone}
          </div>
          {props.lastSubmitted.company ? (
            <div className="mb-2">
              <span className="fw-semibold text-dark">Company:</span> {props.lastSubmitted.company}
            </div>
          ) : null}
          {props.lastSubmitted.website ? (
            <div className="mb-2">
              <span className="fw-semibold text-dark">Website:</span> {props.lastSubmitted.website}
            </div>
          ) : null}
        </div>

        <div className="d-flex flex-column flex-sm-row gap-2 mt-3">
          <Button className="rounded-pill px-4" variant="primary" onClick={props.onReset}>
            Submit another request
          </Button>
          <Button className="rounded-pill px-4" variant="outline-secondary" href="/">
            Back to top
          </Button>
        </div>
      </Card.Body>
    </Card>
  ) : (
    <Card className="shadow-sm border-0 rounded-4">
      <Card.Body className="p-4">
        {props.submitError ? (
          <Alert variant="danger" className="rounded-4">
            <div className="fw-semibold mb-1">Please fix the following:</div>
            <div style={{ whiteSpace: "pre-line" }}>{props.submitError}</div>
          </Alert>
        ) : null}

        {showWarn ? (
          <Alert variant="warning" className="rounded-4">
            {props.serverStatus?.message || "There was a problem submitting your request."}
          </Alert>
        ) : null}

        <Form onSubmit={props.onSubmit}>
          <Row className="g-3">
            <Col md={6}>
              <Form.Label>Full name *</Form.Label>
              <Form.Control
                value={props.form.fullName}
                onChange={(e) => props.onChange("fullName", e.target.value)}
                placeholder="Jordan Miller"
                className="rounded-3"
                disabled={props.submitting}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Email *</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <Envelope />
                </InputGroup.Text>
                <Form.Control
                  value={props.form.email}
                  onChange={(e) => props.onChange("email", e.target.value)}
                  placeholder="you@company.com"
                  className="rounded-end-3"
                  disabled={props.submitting}
                />
              </InputGroup>
            </Col>

            <Col md={6}>
              <Form.Label>Phone *</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <Telephone />
                </InputGroup.Text>
                <Form.Control
                  value={props.form.phone}
                  onChange={(e) => props.onChange("phone", e.target.value)}
                  placeholder="(555) 555-5555"
                  className="rounded-end-3"
                  disabled={props.submitting}
                />
              </InputGroup>
              
            </Col>

            <Col md={6}>
              <Form.Label>Company</Form.Label>
              <Form.Control
                value={props.form.company}
                onChange={(e) => props.onChange("company", e.target.value)}
                placeholder="Your company"
                className="rounded-3"
                disabled={props.submitting}
              />
            </Col>


            <Col md={12}>
                <div className="small text-muted mt-1">We’ll use this information for follow-up and onboarding purposes only.
                  <br></br>
                  <b><i>We will not sell your data, bother you or spam you. </i></b>
                  </div>
            </Col>


            <Col md={12}>
              
              <Form.Label>Website</Form.Label>
              <Form.Control
                value={props.form.website}
                onChange={(e) => props.onChange("website", e.target.value)}
                placeholder="https://example.com"
                className="rounded-3"
                disabled={props.submitting}
              />
            </Col>

            {/* <Col md={12}>
              <Form.Label>Primary objectives *</Form.Label>
              <div className="d-flex flex-wrap gap-2">
                {PRIMARY_OBJECTIVE_OPTIONS.map((opt) => (
                  <Button
                    key={opt}
                    size="sm"
                    type="button"
                    variant={props.form.primaryObjectives.includes(opt) ? "primary" : "outline-primary"}
                    className="rounded-pill px-3"
                    disabled={props.submitting}
                    onClick={() =>
                      props.onChange(
                        "primaryObjectives",
                        toggleInArray(props.form.primaryObjectives, opt).join("|||")
                      )
                    }
                  >
                    {opt}
                  </Button>
                ))}
              </div>
              <div className="small text-muted mt-2">
                Tip: pick the top 1–3 outcomes you want LiveAgent365 to handle first.
              </div>
            </Col> */}


      {/* <Col md={12}>
              <Form.Label>Primary objectives *</Form.Label>

              <div className="d-flex flex-column gap-2">
                {PRIMARY_OBJECTIVE_OPTIONS.map((opt) => (
                  <Form.Check
                    key={opt}
                    type="checkbox"
                    id={`primaryObjective-${opt}`}
                    label={opt}
                    disabled={props.submitting}
                    checked={props.form.primaryObjectives.includes(opt)}
                    onChange={() =>
                      props.onChange(
                        "primaryObjectives",
                        toggleInArray(props.form.primaryObjectives, opt).join("|||")
                      )
                    }
                  />
                ))}
              </div>

              <div className="small text-muted mt-2">
                Tip: pick the top 1–3 outcomes you want LiveAgent365 to handle first.
              </div>
            </Col> */}
                

        <Col md={12}>
            <Form.Label>Primary objectives *</Form.Label>

            <div className="p-3 rounded-3 border bg-white">
              <Row className="g-2">
                {PRIMARY_OBJECTIVE_OPTIONS.map((opt) => {
                  const checked = props.form.primaryObjectives.includes(opt);

                  return (
                    <Col key={opt} xs={12} md={6}>
                      <div className="d-flex align-items-start">
                        <Form.Check
                          type="checkbox"
                          id={`primaryObjective-${opt}`}
                          className="mb-0"
                          label={<span className="small">{opt}</span>}
                          disabled={props.submitting}
                          checked={checked}
                          onChange={() =>
                            props.onChange(
                              "primaryObjectives",
                              toggleInArray(props.form.primaryObjectives, opt).join("|||")
                            )
                          }
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <div className="small text-muted mt-2">
                {/* Tip: pick the top 1–3 outcomes you want LiveAgent365 to handle first. */}
                Choose all that apply.
              </div>
            </div>
          </Col>


            <Col md={12}>
              <Form.Label>Estimated call volume</Form.Label>
              <Form.Select
                className="rounded-3"
                value={props.form.callVolume}
                disabled={props.submitting}
                onChange={(e) => props.onChange("callVolume", e.target.value)}
              >
                <option>0–20 calls/day</option>
                <option>21–50 calls/day</option>
                <option>51–100 calls/day</option>
                <option>101–250 calls/day</option>
                <option>250+ calls/day</option>
              </Form.Select>
            </Col>

            <Col md={12}>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={props.form.notes}
                onChange={(e) => props.onChange("notes", e.target.value)}
                placeholder="Anything we should know? (hours, services, booking preferences, systems, etc.)"
                className="rounded-3"
                disabled={props.submitting}
              />
            </Col>

            
            <Col md={12}>
              <style>{`                #smsConsent.form-check-input,
                #smsMarketingConsent.form-check-input,
                #smsNonMarketingConsent.form-check-input {
                  border: 3px solid var(--bs-primary);
                }
                .sms-consent-highlight .form-check-input {
                  border: 3px solid var(--bs-primary);
                  box-shadow: 0 0 0 .3rem rgba(247,201,72,0.35);
                }.consent-help {
                  margin-left: 1.75rem; /* align with checkbox label text */
                }
              `}</style>
              <div className={(smsConsentMissing ? "sms-consent-highlight " : "") + "mt-2"}>
                <Form.Check
                  type="checkbox"
                  id="smsMarketingConsent"
                  className="mt-1"
                  checked={Boolean(props.form.smsMarketingConsent)}
                  disabled={props.submitting}
                  onChange={(e) => props.onChange("smsMarketingConsent", e.target.checked)}
                  label={
                    <span className="small">
                      I consent to receive <span className="fw-semibold">marketing</span> text messages from{" "}
                      <span className="fw-semibold">LiveAgent365</span> at the phone number provided. Frequency may vary.
                      Message &amp; data rates may apply. Text HELP for assistance, reply STOP to opt out.
                    </span>
                  }
                />
                <Form.Check
                  type="checkbox"
                  id="smsNonMarketingConsent"
                  className="mt-1"
                  checked={Boolean(props.form.smsNonMarketingConsent)}
                  disabled={props.submitting}
                  onChange={(e) => props.onChange("smsNonMarketingConsent", e.target.checked)}
                  label={
                    <span className="small">
                      I consent to receive <span className="fw-semibold">non-marketing</span> text messages from{" "}
                      <span className="fw-semibold">LiveAgent365</span> about my order updates, appointment reminders etc.
                      Frequency may vary. Message &amp; data rates may apply. Text HELP for assistance, reply STOP to opt out.
                    </span>
                  }
                />
              </div>


              
            </Col>

            <Col md={12} className="mt-2">
              <Button
                type="submit"
                variant="primary"
                className="w-100 rounded-pill py-2"
                disabled={props.submitting}
              >
                {props.submitting ? "Submitting..." : "Request a demo"}
              </Button>
              <div className="small text-muted mt-2 text-center">
                We respect your inbox. You can opt out anytime. For SMS, reply STOP to unsubscribe.
              </div>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

// -------------------------------------------------------------------------------------------------------------
// Policy / Contact pages (reactset components)
// -------------------------------------------------------------------------------------------------------------

const POLICY_CONTAINER_STYLE: React.CSSProperties = { maxWidth: 980 };





















//PRIVACY POLICY =================================================================
const LiveAgent365PrivacyPolicyPage_v02: React.FC = () => {
  return (
    <div>
      <LiveAgent365Header
        brandName={String(brand.name)}
        phoneDisplay={CONTACT_PHONE_DISPLAY}
        phoneTel={CONTACT_PHONE_TEL}
        navItems={LANDING_NAV_ITEMS}
        contactSectionId={sectionId.contact}
      />

      <Container className="py-5" style={POLICY_CONTAINER_STYLE}>
        <Card className="shadow-sm border-0 rounded-4">
          <Card.Body className="p-4 p-md-5">
            <h1 className="fw-bold mb-2">Privacy Policy</h1>
            <div className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</div>

            <h5 className="fw-semibold">What we collect</h5>
            <ul className="text-muted">
              <li>Contact details you provide (name, email, phone, company, website).</li>
              <li>Messages and notes you submit through forms.</li>
              <li>Basic technical data (IP, browser, device, pages viewed) for security and analytics.</li>
            </ul>

            <h5 className="fw-semibold mt-4">How we use it</h5>
            <ul className="text-muted">
              <li>To respond to demo requests and provide support.</li>
              <li>To operate, secure, and improve the service.</li>
              <li>To communicate about your request (including SMS if you opt in).</li>
            </ul>

            <h5 className="fw-semibold mt-4">SMS privacy</h5>
            <p className="text-muted mb-2">
              If you opt in to receive SMS messages, we will use your phone number to send service-related messages
              related to your request (such as demo scheduling, support updates, and account-related communication).
              Message frequency varies. Message and data rates may apply.
            </p>
            <p className="text-muted mb-2">
              You can opt out at any time by replying <b>STOP</b>. Reply <b>HELP</b> for help.
            </p>
            <p className="text-muted mb-0">
              We do not sell your phone number, and we do not share mobile information with third parties or affiliates
              for marketing or promotional purposes.
            </p>

            <h5 className="fw-semibold mt-4">Sharing</h5>
            <p className="text-muted">
              We may share data with service providers that help us operate the site (hosting, analytics,
              communications) under confidentiality obligations, or when required by law. Mobile information is not
              shared with third parties or affiliates for marketing or promotional purposes.
            </p>

            <h5 className="fw-semibold mt-4">Contact</h5>
            <p className="text-muted mb-0">
              Questions? Email <a href="mailto:support@liveagent365.com">support@liveagent365.com</a>.
            </p>
          </Card.Body>
        </Card>

        <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
      </Container>
    </div>
  );
};





// const LiveAgent365PrivacyPolicy_v02: React.FC = () => {
//   return (
//     <div>
//       <LiveAgent365Header
//         brandName={String(brand.name)}
//         phoneDisplay={CONTACT_PHONE_DISPLAY}
//         phoneTel={CONTACT_PHONE_TEL}

//ODDFIX
        // navItems={LANDING_NAV_ITEMS}
        // contactSectionId={sectionId.contact}
//       />
//       <Container className="py-5" style={POLICY_CONTAINER_STYLE}>
//         <Card className="shadow-sm border-0 rounded-4">
//           <Card.Body className="p-4 p-md-5">
//             <h1 className="fw-bold mb-2">Privacy Policy</h1>
//             <div className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</div>

//             <h5 className="fw-semibold">What we collect</h5>
//             <ul className="text-muted">
//               <li>Contact details you provide (name, email, phone, company, website).</li>
//               <li>Messages and notes you submit through forms.</li>
//               <li>Basic technical data (IP, browser, device, pages viewed) for security and analytics.</li>
//             </ul>

//             <h5 className="fw-semibold mt-4">How we use it</h5>
//             <ul className="text-muted">
//               <li>To respond to demo requests and provide support.</li>
//               <li>To operate, secure, and improve the service.</li>
//               <li>To communicate about your request (including SMS if you opt in).</li>
//             </ul>

//             <h5 className="fw-semibold mt-4">SMS privacy</h5>
//             <p className="text-muted mb-2">
//               If you opt in to SMS, we will use your phone number to send service-related messages.
//               We do not sell your phone number. You can opt out anytime by replying STOP.
//             </p>

//             <h5 className="fw-semibold mt-4">Sharing</h5>
//             <p className="text-muted">
//               We may share data with service providers that help us operate the site (hosting, analytics,
//               communications) under confidentiality obligations, or when required by law.
//             </p>

//             <h5 className="fw-semibold mt-4">Contact</h5>
//             <p className="text-muted mb-0">
//               Questions? Email <a href="mailto:support@liveagent365.com">support@liveagent365.com</a>.
//             </p>
//           </Card.Body>
//         </Card>

//         <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
//       </Container>
//     </div>
//   );
// };











//TOS ============================================================
const LiveAgent365TermsOfServicePage_v02: React.FC = () => {
  return (
    <div>
      <LiveAgent365Header
        brandName={String(brand.name)}
        phoneDisplay={CONTACT_PHONE_DISPLAY}
        phoneTel={CONTACT_PHONE_TEL}
        navItems={LANDING_NAV_ITEMS}
        contactSectionId={sectionId.contact}
      />

      <Container className="py-5" style={POLICY_CONTAINER_STYLE}>
        <Card className="shadow-sm border-0 rounded-4">
          <Card.Body className="p-4 p-md-5">
            <h1 className="fw-bold mb-2">Terms of Service</h1>
            <div className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</div>

            <p className="text-muted">
              These Terms govern your access to and use of LiveAgent365. By using the site or requesting a demo, you
              agree to these Terms.
            </p>

            <h5 className="fw-semibold mt-4">Acceptable use</h5>
            <ul className="text-muted">
              <li>Do not misuse the site, attempt unauthorized access, or disrupt service.</li>
              <li>Provide accurate information when submitting forms.</li>
            </ul>

            <h5 className="fw-semibold mt-4">Disclaimers</h5>
            <p className="text-muted">
              The site and materials are provided “as is” without warranties of any kind, to the maximum extent
              permitted by law.
            </p>

            <h5 className="fw-semibold mt-4">Limitation of liability</h5>
            <p className="text-muted">
              To the extent permitted by law, LiveAgent365 will not be liable for indirect, incidental, special, or
              consequential damages.
            </p>

            <h5 className="fw-semibold mt-5">SMS Terms / Messaging Policy</h5>
            <p className="text-muted mb-2">
              If you opt in to receive SMS from LiveAgent365, the following applies:
            </p>

            <ul className="text-muted">
              <li>
                <span className="fw-semibold">Program name:</span> LiveAgent365 Messaging.
              </li>
              <li>
                <span className="fw-semibold">Message types:</span> Service-related messages such as demo follow-ups,
                scheduling updates, onboarding information, and support responses.
              </li>
              <li>
                <span className="fw-semibold">Message frequency:</span> Varies.
              </li>
              <li>
                <span className="fw-semibold">Rates:</span> Message and data rates may apply.
              </li>
              <li>
                <span className="fw-semibold">Opt-out:</span> Reply <span className="fw-semibold">STOP</span> to cancel.
              </li>
              <li>
                <span className="fw-semibold">Help:</span> Reply <span className="fw-semibold">HELP</span> for help or
                email{" "}
                <a className="text-decoration-none" href="mailto:support@liveagent365.com">
                  support@liveagent365.com
                </a>
                .
              </li>
              <li>
                <span className="fw-semibold">Consent:</span> Consent to receive SMS is not a condition of purchase.
              </li>
              <li>
                <span className="fw-semibold">Privacy:</span> We do not sell your phone number, and we do not share
                mobile information with third parties or affiliates for marketing or promotional purposes.
              </li>
            </ul>

            <p className="text-muted mb-0">
              For more details about how we handle information, please review our Privacy Policy.
            </p>

            <h5 className="fw-semibold mt-4">Contact</h5>
            <p className="text-muted mb-0">
              Questions about these Terms? Email{" "}
              <a href="mailto:support@liveagent365.com">support@liveagent365.com</a>.
            </p>
          </Card.Body>
        </Card>

        <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
      </Container>
    </div>
  );
};

















//CONTACT PAGE ====================================================
// const LiveAgent365ContactPage_v02: React.FC = () => {
//   return (
//     <div>
//       <LiveAgent365Header
//         brandName={String(brand.name)}
//         phoneDisplay={CONTACT_PHONE_DISPLAY}
//         phoneTel={CONTACT_PHONE_TEL}

// ODD FIX
        // navItems={LANDING_NAV_ITEMS}
        // contactSectionId={sectionId.contact}
//       />
//       <Container className="py-5">
//         <Row className="g-4">
//           <Col lg={5}>
//             <Card className="shadow-sm border-0 rounded-4">
//               <Card.Body className="p-4">
//                 <h2 className="fw-bold mb-3">Contact</h2>
//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Business</div>
//                   <div>{String(brand.name)}</div>
//                 </div>
//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Email</div>
//                   <div>
//                     <a href="mailto:support@liveagent365.com" className="text-decoration-none">
//                       support@liveagent365.com
//                     </a>
//                   </div>
//                 </div>
//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Phone</div>
//                   <div>
//                     <a href={`tel:${CONTACT_PHONE_TEL}`} className="text-decoration-none">
//                       {CONTACT_PHONE_DISPLAY}
//                     </a>
//                   </div>
//                 </div>
//                 <div className="text-muted">
//                   <div className="fw-semibold text-dark">Address</div>
//                   <div>Denver, CO (update address in code)</div>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           <Col lg={7}>
//             {/* Re-use the same demo request panel */}
//             <RequestDemoPanel_v02_A2P
//               form={{
//                 fullName: "",
//                 email: "",
//                 phone: "",
//                 company: "",
//                 website: "",
//                 primaryObjectives: ["Missed calls & lead capture"],
//                 callVolume: "0–20 calls/day",
//                 notes: "",
//                 smsConsent: false,
//     legalConsent: false,
//               }}
//               submitting={false}
//               submitError={null}
//               submitOk={false}
//               lastSubmitted={null}
//               serverStatus={null}
//               onChange={() => {}}
//               onSubmit={(e) => e.preventDefault()}
//               onReset={() => {}}
//             />

//             <div className="small text-muted mt-3">
//               Note: wire this page to your app’s state / API the same way as the landing page.
//             </div>
//           </Col>
//         </Row>

//         <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
//       </Container>
//     </div>
//   );
// };



// DROP-IN REPLACEMENT: LiveAgent365ContactPage_v02
// Fixes “can’t type in inputs” by wiring the RequestDemoPanel to local state (instead of a hard-coded form + no-op onChange).



// const LiveAgent365ContactPage_v02: React.FC = () => {
//   // Local (page-scoped) form state so inputs are editable
//   type DemoFormState = {
//     fullName: string;
//     email: string;
//     phone: string;
//     company: string;
//     website: string;
//     primaryObjectives: string[];
//     callVolume: string;
//     notes: string;
//     smsConsent: boolean;
//   };

//   const DEFAULT_FORM: DemoFormState = {
//     fullName: "",
//     email: "",
//     phone: "",
//     company: "",
//     website: "",
//     primaryObjectives: ["Missed calls & lead capture"],
//     callVolume: "0–20 calls/day",
//     notes: "",
//     smsConsent: false,
//     legalConsent: false,
//   };

//   const [form, setForm] = React.useState<DemoFormState>(DEFAULT_FORM);
//   const [submitting, setSubmitting] = React.useState<boolean>(false);
//   const [submitError, setSubmitError] = React.useState<string | null>(null);
//   const [submitOk, setSubmitOk] = React.useState<boolean>(false);
//   const [lastSubmitted, setLastSubmitted] = React.useState<string | null>(null);
//   const [serverStatus, setServerStatus] = React.useState<string | null>(null);

//   return (
//     <div>
//       <LiveAgent365Header
//         brandName={String(brand.name)}
//         phoneDisplay={CONTACT_PHONE_DISPLAY}
//         phoneTel={CONTACT_PHONE_TEL}
// ODDFIX
        // navItems={LANDING_NAV_ITEMS}
        // contactSectionId={sectionId.contact}
//       />

//       <Container className="py-5">
//         <Row className="g-4">
//           <Col lg={5}>
//             <Card className="shadow-sm border-0 rounded-4">
//               <Card.Body className="p-4">
//                 <h2 className="fw-bold mb-3">Contact</h2>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Business</div>
//                   <div>{String(brand.name)}</div>
//                 </div>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Email</div>
//                   <div>
//                     <a href="mailto:support@liveagent365.com" className="text-decoration-none">
//                       support@liveagent365.com
//                     </a>
//                   </div>
//                 </div>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Phone</div>
//                   <div>
//                     <a href={`tel:${CONTACT_PHONE_TEL}`} className="text-decoration-none">
//                       {CONTACT_PHONE_DISPLAY}
//                     </a>
//                   </div>
//                 </div>

//                 <div className="text-muted">
//                   <div className="fw-semibold text-dark">Address</div>
//                   <div>Denver, CO (update address in code)</div>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           <Col lg={7}>
//             {/* Re-use the same demo request panel (now wired to state so inputs work) */}
//             <RequestDemoPanel_v02_A2P
//               form={form as any}
//               submitting={submitting}
//               submitError={submitError}
//               submitOk={submitOk}
//               lastSubmitted={lastSubmitted}
//               serverStatus={serverStatus as any}
//               onChange={(key: any, value: any) => {
//                 setSubmitOk(false);
//                 setSubmitError(null);
//                 setServerStatus(null);

//                 setForm((p) => {
//                   // keep your existing primaryObjectives serialization format (|||) used by the panel
//                   if (key === "primaryObjectives") {
//                     const next = String(value)
//                       .split("|||")
//                       .map((s) => s.trim())
//                       .filter(Boolean);
//                     return { ...p, primaryObjectives: next };
//                   }

//                   if (key === "smsConsent") {
//                     const next = value === true || value === "true";
//                     return { ...p, smsConsent: next };
//                   }

//                   // default: string fields
//                   return { ...p, [String(key)]: String(value) } as DemoFormState;
//                 });
//               }}
//               onSubmit={(e: any) => {
//                 e.preventDefault();

//                 // If your panel already validates smsConsent internally, this is harmless redundancy.
//                 if (!form.smsConsent) {
//                   setSubmitOk(false);
//                   setSubmitError("Please check the SMS consent box to receive text updates.");
//                   setServerStatus("error");
//                   return;
//                 }

//                 setSubmitting(true);
//                 setSubmitError(null);
//                 setSubmitOk(false);
//                 setServerStatus(null);

//                 // IMPORTANT:
//                 // If you have a real submit function used on the landing page, call it here.
//                 // For now, this “stub” just demonstrates a working form UX on the Contact page.
//                 try {
//                   setLastSubmitted(new Date().toISOString());
//                   setSubmitOk(true);
//                   setServerStatus("ok");
//                 } catch (err: any) {
//                   setSubmitOk(false);
//                   setSubmitError(err?.message || "Something went wrong. Please try again.");
//                   setServerStatus("error");
//                 } finally {
//                   setSubmitting(false);
//                 }
//               }}
//               onReset={() => {
//                 setForm(DEFAULT_FORM);
//                 setSubmitting(false);
//                 setSubmitError(null);
//                 setSubmitOk(false);
//                 setLastSubmitted(null);
//                 setServerStatus(null);
//               }}
//             />

//             <div className="small text-muted mt-3">
//               Note: wire this page to your app’s state / API the same way as the landing page.
//             </div>
//           </Col>
//         </Row>

//         <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
//       </Container>
//     </div>
//   );
// };



// DROP-IN REPLACEMENT: LiveAgent365ContactPage_v02
// Fixes “can’t type in inputs” by wiring RequestDemoPanel_v02_A2P to local state
// and by providing correctly-typed lastSubmitted: VoiceAgentLeadPayload | null.

// const LiveAgent365ContactPage_v02: React.FC = () => {
//   // Match the form shape that RequestDemoPanel_v02_A2P expects (landing page fields + smsConsent)
//   type DemoFormState = {
//     fullName: string;
//     email: string;
//     phone: string;
//     company: string;
//     website: string;
//     primaryObjectives: string[];
//     callVolume: string;
//     notes: string;
//     smsConsent: boolean;
//   };

//   const DEFAULT_FORM: DemoFormState = {
//     fullName: "",
//     email: "",
//     phone: "",
//     company: "",
//     website: "",
//     primaryObjectives: ["Missed calls & lead capture"],
//     callVolume: "0–20 calls/day",
//     notes: "",
//     smsConsent: false,
//     legalConsent: false,
//   };

//   const [form, setForm] = React.useState<DemoFormState>(DEFAULT_FORM);
//   const [submitting, setSubmitting] = React.useState<boolean>(false);
//   const [submitError, setSubmitError] = React.useState<string | null>(null);
//   const [submitOk, setSubmitOk] = React.useState<boolean>(false);

//   // IMPORTANT: RequestDemoPanel expects VoiceAgentLeadPayload | null
//   const [lastSubmitted, setLastSubmitted] = React.useState<VoiceAgentLeadPayload | null>(null);

//   // Keep minimal + generic; adjust if your panel expects a different shape/enum
//   const [serverStatus, setServerStatus] = React.useState<"ok" | "error" | null>(null);

//   // Helper: parent-style "onChange" expected by the panel (strings + special cases)
//   const handlePanelChange = (key: string, value: string | boolean) => {
//     setSubmitOk(false);
//     setSubmitError(null);
//     setServerStatus(null);

//     setForm((p) => {
//       if (key === "primaryObjectives") {
//         // Panel uses "|||" serialization
//         const next = String(value)
//           .split("|||")
//           .map((s) => s.trim())
//           .filter(Boolean);
//         return { ...p, primaryObjectives: next };
//       }

//       if (key === "smsConsent") {
//         const next = value === true || value === "true";
//         return { ...p, smsConsent: next };
//       }

//       // Default: string fields
//       return { ...p, [key]: String(value) } as DemoFormState;
//     });
//   };

//   const handlePanelReset = () => {
//     setForm(DEFAULT_FORM);
//     setSubmitting(false);
//     setSubmitError(null);
//     setSubmitOk(false);
//     setLastSubmitted(null);
//     setServerStatus(null);
//   };

//   const handlePanelSubmit = (e: React.FormEvent) => {
//     e.preventDefault();

//     // If the panel already validates smsConsent, this is harmless redundancy.
//     if (!form.smsConsent) {
//       setSubmitOk(false);
//       setSubmitError("Please check the SMS consent box to receive text updates.");
//       setServerStatus("error");
//       return;
//     }

//     setSubmitting(true);
//     setSubmitError(null);
//     setSubmitOk(false);
//     setServerStatus(null);

//     try {
//       // If you have a real submit function used on the landing page, call it here.
//       // This creates a correctly shaped payload so the panel can show a “submitted” state.
//       const payload: VoiceAgentLeadPayload = {
//         // Landing page fields
//         fullName: form.fullName,
//         email: form.email,
//         phone: form.phone,
//         company: form.company,
//         website: form.website,
//         primaryObjectives: form.primaryObjectives,
//         callVolume: form.callVolume,
//         notes: form.notes,

//         // A2P fields
//         smsConsent: form.smsConsent,
//         smsConsentText:
//           // Use your exact consent text constant if you have it in this file.
//           // If not, replace this with the exact text displayed next to your consent checkbox.
//           (typeof (globalThis as any).SMS_CONSENT_TEXT === "string"
//             ? (globalThis as any).SMS_CONSENT_TEXT
//             : "By checking this box, you consent to receive text messages from LiveAgent365 related to your request. Message frequency varies. Msg & data rates may apply. Reply STOP to opt out. Reply HELP for help."),
//         smsConsentSource: "contact-page",

//         // Metadata
//         domainName: window.location.hostname,
//         itemCategory: "Lead",
//         itemClass: "WebForm",
//         itemType: "RequestDemo",
//         clientVersion: VERSION,
//       };

//       setLastSubmitted(payload);
//       setSubmitOk(true);
//       setServerStatus("ok");
//     } catch (err: unknown) {
//       const msg = err instanceof Error ? err.message : "Something went wrong. Please try again.";
//       setSubmitOk(false);
//       setSubmitError(msg);
//       setServerStatus("error");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div>
//       <LiveAgent365Header
//         brandName={String(brand.name)}
//         phoneDisplay={CONTACT_PHONE_DISPLAY}
//         phoneTel={CONTACT_PHONE_TEL}

//ODD FIX
        // navItems={LANDING_NAV_ITEMS}
        // contactSectionId={sectionId.contact}
//       />

//       <Container className="py-5">
//         <Row className="g-4">
//           <Col lg={5}>
//             <Card className="shadow-sm border-0 rounded-4">
//               <Card.Body className="p-4">
//                 <h2 className="fw-bold mb-3">Contact</h2>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Business</div>
//                   <div>{String(brand.name)}</div>
//                 </div>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Email</div>
//                   <div>
//                     <a href="mailto:support@liveagent365.com" className="text-decoration-none">
//                       support@liveagent365.com
//                     </a>
//                   </div>
//                 </div>

//                 <div className="text-muted mb-2">
//                   <div className="fw-semibold text-dark">Phone</div>
//                   <div>
//                     <a href={`tel:${CONTACT_PHONE_TEL}`} className="text-decoration-none">
//                       {CONTACT_PHONE_DISPLAY}
//                     </a>
//                   </div>
//                 </div>

//                 <div className="text-muted">
//                   <div className="fw-semibold text-dark">Address</div>
//                   <div>Denver, CO (update address in code)</div>
//                 </div>
//               </Card.Body>
//             </Card>
//           </Col>

//           <Col lg={7}>
//             {/* Re-use the same demo request panel (now wired to state so inputs work) */}
//             <RequestDemoPanel_v02_A2P
//               form={form}
//               submitting={submitting}
//               submitError={submitError}
//               submitOk={submitOk}
//               lastSubmitted={lastSubmitted}
//               serverStatus={serverStatus}
//               onChange={handlePanelChange}
//               onSubmit={handlePanelSubmit}
//               onReset={handlePanelReset}
//             />

//             <div className="small text-muted mt-3">
//               Note: wire this page to your app’s state / API the same way as the landing page.
//             </div>
//           </Col>
//         </Row>

//         <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
//       </Container>
//     </div>
//   );
// };


/* =====================================================================================
File: LiveAgent365_v02_updated_fixed7_router_header_footer_contact.tsx
Desc: Integrates the LiveAgent365 Contact page (v03a-style implementation) INTO the existing
      router/header/footer/contact file (not stand-alone), while submitting to the same API
      as the landing page (buildLeadPayload -> toWirePayloadStrings -> postLead).

Version: v02.7.0
Changelog:
- v02.7.0: Added ContactRoute_v03a (inline) that reuses RequestDemoPanel_v02_A2P and posts to landing-page API
- v02.7.0: serverStatus aligned to panel type: { ok, status, id?, message? } | null
- v02.7.0: Kept v02-style handler structure (handlePanelChange/reset/submit) while making submit async + API-backed

Chat: https://chatgpt.com/  (paste your specific chat link here)
===================================================================================== */

// import React from "react";
// import { Container, Row, Col, Card } from "react-bootstrap";
// import { Routes, Route, Navigate } from "react-router-dom";

// // Existing app components (already in this file, or keep your current imports)
// import LiveAgent365Header from "./LiveAgent365Header";
// import LiveAgent365Footer_v02 from "./LiveAgent365Footer_v02";
// import RequestDemoPanel_v02_A2P from "./RequestDemoPanel_v02_A2P";

// // Types + helpers used by your landing page API pipeline (use the SAME ones you already use there)
// import type { VoiceAgentLeadPayload } from "../types/VoiceAgentLeadPayload";
// import { postLead } from "../api/postLead";
// import { toWirePayloadStrings } from "../api/toWirePayloadStrings";
// import { digitsOnly } from "../utils/digitsOnly";

// // Assume these exist in your existing file already (keep your current sources if different)
// declare const brand: { name: string };
// declare const CONTACT_PHONE_DISPLAY: string;
// declare const CONTACT_PHONE_TEL: string;
// declare const VERSION: string;

// // Use the same exact consent text as the landing page for consistency
// const SMS_CONSENT_TEXT =
//   "By checking the box, you agree to receive SMS text messages from LiveAgent365. Msg & data rates may apply. Msg frequency varies. Reply STOP to opt out; HELP for help. Consent is not a condition of purchase.";

type ServerStatus = { ok: boolean; status: number; id?: string; message?: string } | null;

/* =====================================================================================
  ROUTE COMPONENT (INLINE): ContactRoute_v03a
  - Implementation intentionally mirrors your original LiveAgent365ContactPage_v02 structure
  - Now posts to the same API pipeline as the landing page
===================================================================================== */


/* ContactRoute_v03a moved to ContactPage_v03a.tsx */






/* =====================================================================================
  MAIN SHELL: Router + Header + Footer
  - This is the part that typically already exists in your fixed7 file
  - Add/keep the /contact route pointing to ContactRoute_v03a
===================================================================================== */
// export  function LiveAgent365_v02_updated_fixed7_router_header_footer_contact() {
//   return (
//     <div>
//       <LiveAgent365Header
//         brandName={String(brand.name)}
//         phoneDisplay={CONTACT_PHONE_DISPLAY}
//         phoneTel={CONTACT_PHONE_TEL}

//ODDFIX
        // navItems={LANDING_NAV_ITEMS}
        // contactSectionId={sectionId.contact}
//       />

//       <Routes>
//         {/* Keep your existing routes here */}
//         {/* Example:
//         <Route path="/" element={<HomeRoute />} />
//         <Route path="/pricing" element={<PricingRoute />} />
//         */}

//         {/* ✅ Contact route now uses the integrated API-compatible contact form */}
//         <Route path="/contact" element={<ContactPage_v03a />} />

//         {/* Optional: redirect unknown routes */}
//         <Route path="*" element={<Navigate to="/contact" replace />} />
//       </Routes>

//       <LiveAgent365Footer_v02 brandName={String(brand.name)} version={String(VERSION)} />
//     </div>
//   );
// }

/* =====================================================================================
File: LiveAgent365_v02_updated_fixed7_router_header_footer_contact.tsx
Desc: Router/header/footer wrapper with integrated API-compatible contact route (v03a-style)
Version: v02.7.0
===================================================================================== */












// ROUTING==========================================================
// Named exports for routing
export { LiveAgent365PrivacyPolicyPage_v02 as LiveAgent365PrivacyPolicy_v02, 
  LiveAgent365TermsOfServicePage_v02 as LiveAgent365Terms_v02, ContactPage_v03a };


export function LiveAgent365Page_v02_v3g_A2P() {
  const [form, setForm] = useState<LeadFormState>({
    fullName: "",
    email: "",
    phone: "",
    company: "",
    website: "",
    primaryObjectives: ["Missed calls & lead capture"],
    callVolume: "0–20 calls/day",
    notes: "",
    smsConsent: false,
    smsMarketingConsent: false,
    smsNonMarketingConsent: false,
});

  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [serverStatus, setServerStatus] = useState<{
    ok: boolean;
    status: number;
    id?: string;
    message?: string;
  } | null>(null);

  const [submitOk, setSubmitOk] = useState(false);
  const [lastSubmitted, setLastSubmitted] = useState<VoiceAgentLeadPayload | null>(null);

  const isValid = useMemo(() => {
    const emailOk = /^\S+@\S+\.\S+$/.test(form.email.trim());
    const nameOk = form.fullName.trim().length >= 2;
    const phoneDigits = form.phone.replace(/\D/g, "");
    const phoneOk = phoneDigits.length === 10 || phoneDigits.length === 0;
    const objectivesOk = form.primaryObjectives.length >= 1;
    const smsOk = true; // SMS checkboxes are optional (A2P)
const phoneRequiredOk = phoneDigits.length === 10;
    return emailOk && nameOk && phoneRequiredOk && objectivesOk && smsOk;
  }, [form]);

  const onChange = (k: keyof LeadFormState, v: string | boolean) =>
    setForm((p) => {
      if (k === "primaryObjectives") {
        const s = String(v || "");
        const next = s.includes("|||") ? s.split("|||").filter(Boolean) : [s].filter(Boolean);
        return { ...p, primaryObjectives: next };
      }
      return { ...p, [k]: v } as LeadFormState;
    });

  function buildLeadPayload(): VoiceAgentLeadPayload {
    return {
      fullName: form.fullName.trim(),
      email: form.email.trim(),
      phone: digitsOnly(form.phone),
      company: form.company.trim(),
      website: (form.website || "").trim(),

      primaryObjectives: form.primaryObjectives,
      callVolume: form.callVolume,
      notes: (form.notes || "").trim(),

      smsConsent: Boolean(form.smsConsent),
      smsConsentText: "By checking the box, you agree to receive SMS text messages from LiveAgent365. Msg & data rates may apply. Msg frequency varies. Reply STOP to opt out; HELP for help. Consent is not a condition of purchase.",
      smsConsentSource: "web_form",
domainName: typeof window !== "undefined" ? String(window.location.hostname) : "unknown",
      itemCategory: "Customer.liveagent365.demo",
      itemClass: "demo.request",
      itemType: "liveagent365.landing",
      clientVersion: String(VERSION),
    };
  }

  const resetForNew = () => {
    setSubmitting(false);
    setSubmitError(null);
    setServerStatus(null);
    setSubmitOk(false);
    setLastSubmitted(null);

    setForm({
      fullName: "",
      email: "",
      phone: "",
      company: "",
      website: "",
      primaryObjectives: ["Missed calls & lead capture"],
      callVolume: "0–20 calls/day",
      notes: "",
      smsConsent: false,
      smsMarketingConsent: false,
      smsNonMarketingConsent: false,
});

    setTimeout(() => scrollToId(sectionId.contact), 50);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setSubmitError(null);
    setServerStatus(null);
    setSubmitOk(false);

    if (!isValid) {
      const emailOk = /^\S+@\S+\.\S+$/.test(form.email.trim());
      const nameOk = form.fullName.trim().length >= 2;
      const phoneDigits = form.phone.replace(/\D/g, "");
      const phoneOk = phoneDigits.length === 10;
      const objectivesOk = form.primaryObjectives.length >= 1;
      const smsOk = true; // SMS checkboxes are optional (A2P)
const issues: string[] = [];
      if (!nameOk) issues.push("Enter your full name.");
      if (!emailOk) issues.push("Enter a valid email address.");
      if (!phoneOk) issues.push("Enter a 10-digit phone number.");
      if (!objectivesOk) issues.push("Select at least one primary objective.");
if (!smsOk) issues.push("SMS consent required: check the SMS consent box (below).");

      // setSubmitError(`Please fix the following:\n• ${issues.join("\n• ")}`);
      setSubmitError(`• ${issues.join("\n• ")}`);
      return;
    }

    const appPayload = buildLeadPayload();
    const wirePayload = toWirePayloadStrings(appPayload);

    try {
      setSubmitting(true);

      const status = await postLead(wirePayload);
      setServerStatus(status);

      if (!status.ok) throw new Error(status.message || "Unknown server error");

      setLastSubmitted(appPayload);
      setSubmitOk(true);

      setTimeout(() => scrollToId(sectionId.contact), 50);
    } catch (err: unknown) {
      const raw = err instanceof Error ? err.message : String(err);
      const msg = `We couldn’t submit your request.\n• Please try again in a moment.\n• If the problem continues, refresh the page and try once more.\n\nDetails: ${raw}`;
      setSubmitError(msg);
      setSubmitOk(false);
    } finally {
      setSubmitting(false);
    }
  };

  const heroTheme = SECTION_THEMES.hero;
  const contactTheme = SECTION_THEMES.contact;

  const contactSubCardTheme =
    SECTION_THEMES.contact.contactSubCards ??
    ({
      label: "Default Contact Sub-Cards",
      cardBackground: "rgba(255,255,255,.72)",
      titleColor: "#212529",
      bodyColor: "rgba(33,37,41,.70)",
      iconBg: "rgba(13,110,253,.14)",
    } as ContactSubCardTheme);

  return (
    <div id={sectionId.top}>
      {/* Global Header */}
      <LiveAgent365Header
        brandName={String(brand.name)}
        phoneDisplay={CONTACT_PHONE_DISPLAY}
        phoneTel={CONTACT_PHONE_TEL}
        navItems={LANDING_NAV_ITEMS}
        contactSectionId={sectionId.contact}
        onNavToSection={(id) => scrollToId(id)}
      />

      {/* Hero */}
      <Section id={sectionId.top} themeKey="hero" className="pt-5">
        <Container className="py-3">

          {/* align hero content toward TOP */}
          <Row className="align-items-start g-4">
            <Col lg={6}>
              {/* <Badge bg="light" text="dark" className="rounded-pill mb-3">
                AI Voice Receptionist • 24/7
              </Badge> */}

              <h1 className="display-6 fw-bold mb-3" style={{ color: heroTheme.textColor }}>
                {brand.tagline}
              </h1>

              <p className="lead mb-4" style={{ color: heroTheme.mutedTextColor }}>
                  {PAGE_CONTENT.hero.subtitle}
                </p>

              <div className="d-flex flex-column flex-sm-row gap-2">
                <Button
                  size="lg"
                  className="rounded-pill px-4"
                  variant="light"
                  onClick={() => scrollToId(sectionId.contact)}
                >
                  <RocketTakeoff className="me-2" />
                  Request a demo
                </Button>
                <Button
                  size="lg"
                  variant="outline-light"
                  className="rounded-pill px-4"
                  onClick={() => scrollToId(sectionId.pricing)}
                >
                  View pricing
                </Button>
              </div>

              <div className="d-flex flex-wrap gap-3 mt-4" style={{ color: heroTheme.mutedTextColor }}>
                <span className="d-inline-flex align-items-center gap-2">
                  <Clock /> 24/7 answering
                </span>
                <span className="d-inline-flex align-items-center gap-2">
                  <ShieldCheck /> Secure summaries
                </span>
                <span className="d-inline-flex align-items-center gap-2">
                  <LightningCharge /> Fast setup
                </span>
              </div>

              <div className="mt-4">
  <div
    className="d-flex align-items-center gap-2 mb-3"
    style={{ color: heroTheme.mutedTextColor }}
  >
    <StarFill className="text-warning" />
    <StarFill className="text-warning" />
    <StarFill className="text-warning" />
    <StarFill className="text-warning" />
    <StarFill className="text-warning" />
    <span>Built for small & mid-size teams who live on the phone.</span>
  </div>

  {/* Single-column use cases */}

  {/* 
  <div
    style={{
      color: heroTheme.textColor,
      fontSize: "1.5rem",
      lineHeight: 1.7,
    }}
  >
    <div className="mb-2">
      <strong>Local service businesses</strong> — capture missed calls and create instant callback opportunities.
    </div>
    <div className="mb-2">
      <strong>Appointment-based offices</strong> — collect name, phone, and preferred times without tying up staff.
    </div>
    <div className="mb-2">
      <strong>Sales-driven teams</strong> — qualify inbound callers and route clean summaries to the right rep.
    </div>
    <div className="mb-2">
      <strong>After-hours operations</strong> — stay responsive nights, weekends, and holidays.
    </div>
    <div className="mb-2">
      <strong>Growing businesses</strong> — handle more calls without hiring or retraining reception staff.
    </div>
    <div>
      <strong>Marketing-focused teams</strong> — see which ads, campaigns, and listings actually drive phone calls.
    </div>
  </div> 
  */}


</div>


            </Col>

            <Col lg={6}>
              <HeroCarousel />

              <Card className="shadow border-0 rounded-4 mt-3">
                <Card.Body className="p-4 p-md-5">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 className="mb-0">Example call summary</h5>
                    <Badge bg="success" className="rounded-pill">
                      Delivered instantly
                    </Badge>
                  </div>

                  <div className="p-3 rounded-4 border bg-light">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <TelephoneInbound />
                      <strong>Inbound Call</strong>
                      <span className="text-muted">• 2m 14s</span>
                    </div>
                    <div className="text-muted small mb-2">
                      Captured key details and routed the request to the right team.
                    </div>

                    <Row className="g-2 small">
                      <Col md={6}>
                        <div className="text-muted">Name</div>
                        <div className="fw-semibold">Jordan M.</div>
                      </Col>
                      <Col md={6}>
                        <div className="text-muted">Phone</div>
                        <div className="fw-semibold">(303) 555-0198</div>
                      </Col>
                      <Col md={6}>
                        <div className="text-muted">Email</div>
                        <div className="fw-semibold">jordan@email.com</div>
                      </Col>
                      <Col md={6}>
                        <div className="text-muted">Topic</div>
                        <div className="fw-semibold">Appointment request / Setting</div>
                      </Col>
                      <Col md={12}>
                        <div className="text-muted">Summary</div>
                        <div className="fw-semibold">
                          Caller wants next available slot this week and asked about pricing. Requested a callback today
                          after 3pm.
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="d-flex flex-wrap gap-2 mt-3">
                    <Badge bg="light" text="dark" className="rounded-pill">
                      Name + Phone capture
                    </Badge>
                    <Badge bg="light" text="dark" className="rounded-pill">
                      Appointment workflows
                    </Badge>
                    <Badge bg="light" text="dark" className="rounded-pill">
                      Email & CRM routing
                    </Badge>
                    <Badge bg="light" text="dark" className="rounded-pill">
                      Custom scripts
                    </Badge>
                  </div>

                  <div className="mt-4 d-flex gap-2">
                    <Button
                      variant="primary"
                      className="rounded-pill px-4"
                      onClick={() => scrollToId(sectionId.contact)}
                    >
                      <Envelope className="me-2" />
                      Get my setup plan
                    </Button>
                    <Button
                      variant="outline-secondary"
                      className="rounded-pill px-4"
                      onClick={() => scrollToId(sectionId.features)}
                    >
                      Explore features
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Section>

      <DividerBand />

      {/* Features */}
      <Section id={sectionId.features} themeKey="features">
        <Container>
          <Row className="mb-4">
            <Col lg={8}>
              <h2 className="fw-bold">{PAGE_CONTENT.features.title}</h2>
              <p className="text-muted mb-0">
                VoiceAgent365 is designed to sound natural, collect accurate info, and keep your team informed.
              </p>
            </Col>
          </Row>

          <Row className="g-3">
            <Col md={6} lg={4}>
              <FeatureCard
                icon={<Mic />}
                title={PAGE_CONTENT.features.cards[0].title}
                desc={PAGE_CONTENT.features.cards[0].desc}
                badge={PAGE_CONTENT.features.cards[0].badge}
              />
            </Col>
            <Col md={6} lg={4}>
              <FeatureCard
                icon={<TelephoneInbound />}
                title={PAGE_CONTENT.features.cards[1].title}
                desc={PAGE_CONTENT.features.cards[1].desc}
                badge={PAGE_CONTENT.features.cards[1].badge}
              />
            </Col>
            <Col md={6} lg={4}>
              <FeatureCard
                icon={<Clock />}
                title={PAGE_CONTENT.features.cards[2].title}
                desc={PAGE_CONTENT.features.cards[2].desc}
              />
            </Col>

            <Col md={6} lg={4}>
              <FeatureCard
                icon={<Envelope />}
                title={PAGE_CONTENT.features.cards[3].title}
                desc={PAGE_CONTENT.features.cards[3].desc}
              />
            </Col>
            <Col md={6} lg={4}>
              <FeatureCard
                icon={<ShieldCheck />}
                title={PAGE_CONTENT.features.cards[4].title}
                desc={PAGE_CONTENT.features.cards[4].desc}
              />
            </Col>
            <Col md={6} lg={4}>
              <FeatureCard
                icon={<GraphUpArrow />}
                title={PAGE_CONTENT.features.cards[5].title}
                desc={PAGE_CONTENT.features.cards[5].desc}
                badge={PAGE_CONTENT.features.cards[2].badge}
              />
            </Col>
          </Row>
        </Container>
      </Section>

      <DividerBand />

      {/* How it works */}
      <Section id={sectionId.how} themeKey="how">
        <Container>
          <Row className="mb-4">
            <Col lg={8}>
              <h2 className="fw-bold">{PAGE_CONTENT.how.title}</h2>
              <p className="text-muted mb-0">{PAGE_CONTENT.how.subtitle}</p>
            </Col>
          </Row>

          <Row className="g-3">
            <Col md={4}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Badge bg="primary" className="rounded-pill">
                      Step 1
                    </Badge>
                    <h5 className="mb-0">{PAGE_CONTENT.how.steps[0].title}</h5>
                  </div>
                  <p className="text-muted mb-0">
                    Tell us what to ask for: name, phone, email, appointment details, and common questions.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Badge bg="primary" className="rounded-pill">
                      Step 2
                    </Badge>
                    <h5 className="mb-0">Route the recap</h5>
                  </div>
                  <p className="text-muted mb-0">
                    Send summaries to email, CRM fields, or your helpdesk so the right person follows up fast.
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Badge bg="primary" className="rounded-pill">
                      Step 3
                    </Badge>
                    <h5 className="mb-0">Go live 24/7</h5>
                  </div>
                  <p className="text-muted mb-0">
                    Start capturing leads immediately—and improve your script as you learn what callers need.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <Alert className="mb-0 rounded-4" variant="primary">
                <div className="d-flex align-items-start gap-3">
                  <div className="mt-1">
                    <Gear />
                  </div>
                  <div>
                    <div className="fw-semibold">Pro tip:</div>
                    <div>
                      If you want callers to provide an email (but no full account signup), we can collect email as a
                      “callback confirmation” step.
                    </div>
                  </div>
                </div>
              </Alert>
            </Col>
          </Row>
        </Container>
      </Section>

      <DividerBand />

      {/* Use cases */}
      <Section id={sectionId.useCases} themeKey="useCases">
        <Container>
          <Row className="mb-4">
            <Col lg={8}>
              <h2 className="fw-bold">{PAGE_CONTENT.useCase.title}</h2>
              <p className="text-muted mb-0">
                Great for local services, appointment-based businesses, and any company that can’t afford missed calls.
              </p>
            </Col>
          </Row>

          <Row className="g-3">
            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Building />
                    <h6 className="mb-0">{PAGE_CONTENT.useCase.cards[0].title}</h6>
                  </div>
                  <div className="text-muted">
                    Capture leads for HVAC, plumbing, tire shops, contractors, cleaning, towing, and more.
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <People />
                    <h6 className="mb-0">Sales teams</h6>
                  </div>
                  <div className="text-muted">Qualify inbound inquiries, route to the right rep, and send recaps. <br></br><br></br> Add a voice entry point to your funnel and see which ads drive calls.</div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Headset />
                    <h6 className="mb-0">{PAGE_CONTENT.useCase.cards[3].title}</h6>
                  </div>
                  <div className="text-muted">Keep your business responsive even when your office is closed.</div>
                </Card.Body>
              </Card>
            </Col>

             <Col md={6} lg={3}>
              <Card className="h-100 shadow-sm border-0 rounded-4">
                <Card.Body className="p-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <RocketTakeoff />
                    <h6 className="mb-0">Real Estate</h6>
                  </div>
                  <div className="text-muted">Capture buyer, seller, renter, and investor leads 24/7. <br></br>Qualify inquiries, route showing requests, and keep deals moving even after hours.</div>
                </Card.Body>
              </Card>
            </Col>


          </Row>
        </Container>
      </Section>

      <DividerBand />

      {/* Pricing */}
      <Section id={sectionId.pricing} themeKey="pricing">
        <Container>
          <Row className="align-items-end mb-4">
            <Col lg={8}>
              <h2 className="fw-bold">{PAGE_CONTENT.pricing.title}</h2>
              <p className="text-muted mb-0">{PAGE_CONTENT.pricing.subtitle}</p>
            </Col>
            <Col lg={4} className="text-lg-end mt-3 mt-lg-0">
              <Badge bg="light" text="dark" className="rounded-pill">
                Ask about annual discounts
              </Badge>
            </Col>
          </Row>

          <Row className="g-3">
            <Col md={6} lg={4}>
              <PriceCard
                name={PAGE_CONTENT.pricing.tiers[0].name}
                price={PAGE_CONTENT.pricing.tiers[0].price}
                subtitle={PAGE_CONTENT.pricing.tiers[0].subtitle}
                bullets={PAGE_CONTENT.pricing.tiers[0].bullets}
                ctaText={PAGE_CONTENT.pricing.tiers[0].ctaText}
              />
            </Col>
            <Col md={6} lg={4}>
              <PriceCard
                name={PAGE_CONTENT.pricing.tiers[1].name}
                price={PAGE_CONTENT.pricing.tiers[1].price}
                subtitle={PAGE_CONTENT.pricing.tiers[1].subtitle}
                bullets={PAGE_CONTENT.pricing.tiers[1].bullets}
                ctaText={PAGE_CONTENT.pricing.tiers[1].ctaText}
                highlight={PAGE_CONTENT.pricing.tiers[1].highlight}
              />
            </Col>
            <Col md={6} lg={4}>
              <PriceCard
                name={PAGE_CONTENT.pricing.tiers[2].name}
                price={PAGE_CONTENT.pricing.tiers[2].price}
                subtitle={PAGE_CONTENT.pricing.tiers[2].subtitle}
                bullets={PAGE_CONTENT.pricing.tiers[2].bullets}
                ctaText={PAGE_CONTENT.pricing.tiers[2].ctaText}
              />
            </Col>
          </Row>

          <div className="text-muted mt-3 small">* Pricing shown as examples for the landing page. Adjust as needed.</div>
        </Container>
      </Section>

      <DividerBand />

      {/* FAQ */}
      <Section id={sectionId.faq} themeKey="faq">
        <Container>
          <Row className="mb-4">
            <Col lg={8}>
              <h2 className="fw-bold">{PAGE_CONTENT.faq.title}</h2>
              <p className="text-muted mb-0">{PAGE_CONTENT.faq.subtitle}</p>
            </Col>
          </Row>

          <Row className="g-3">
            <Col lg={8}>
              <Accordion defaultActiveKey="0" className="rounded-4 overflow-hidden shadow-sm">
                {PAGE_CONTENT.faq.items.map((item, idx) => (
                  <Accordion.Item key={idx} eventKey={String(idx)}>
                    <Accordion.Header>{item.q}</Accordion.Header>
                    <Accordion.Body className="text-muted">{item.a}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>

            <Col lg={4}>
              <Card className="shadow-sm border-0 rounded-4 h-100">
                <Card.Body className="p-4">
                  <h5 className="mb-2">Want a quick setup plan?</h5>
                  <p className="text-muted">
                    Tell us your call volume and objectives and we will help you design and implement a recommended script + routing approach.
                  </p>
                  <Button
                    variant="primary"
                    className="rounded-pill px-4"
                    onClick={() => scrollToId(sectionId.contact)}
                  >
                    Get setup plan
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Section>

      <DividerBand />

      {/* Contact / Lead Form + Confirmation */}
      <Section id={sectionId.contact} themeKey="contact">
        <Container>
          <Row className="align-items-center g-4">
            <Col lg={6}>
              <h2 className="fw-bold" style={{ color: contactTheme.textColor }}>
                Request a demo
              </h2>
              <p className="mb-4" style={{ color: contactTheme.mutedTextColor }}>
                Share a little info and we’ll respond with next steps. If you already know what you want,
                just drop your email + phone and we’ll keep it simple.
              </p>

              <RequestDemoPanel_v02_A2P
                form={form}
                submitting={submitting}
                submitError={submitError}
                submitOk={submitOk}
                lastSubmitted={lastSubmitted}
                serverStatus={serverStatus}
                onChange={onChange}
                onSubmit={onSubmit}
                onReset={resetForNew}
              />
            </Col>

            <Col lg={6}>
              <Row className="g-3">
                <Col md={6}>
                  <ContactSubCard
                    theme={contactSubCardTheme}
                    icon={<LightningCharge />}
                    title={PAGE_CONTENT.contact.subCards[0].title}
                    desc={PAGE_CONTENT.contact.subCards[0].desc}
                  />
                </Col>
                <Col md={6}>
                  <ContactSubCard
                    theme={contactSubCardTheme}
                    icon={<ShieldCheck />}
                    title={PAGE_CONTENT.contact.subCards[1].title}
                    desc={PAGE_CONTENT.contact.subCards[1].desc}
                  />
                </Col>
                <Col md={6}>
                  <ContactSubCard
                    theme={contactSubCardTheme}
                    icon={<GraphUpArrow />}
                    title={PAGE_CONTENT.contact.subCards[2].title}
                    desc={PAGE_CONTENT.contact.subCards[2].desc}
                  />
                </Col>
                <Col md={6}>
                  <ContactSubCard
                    theme={contactSubCardTheme}
                    icon={<Headset />}
                    title={PAGE_CONTENT.contact.subCards[3].title}
                    desc={PAGE_CONTENT.contact.subCards[3].desc}
                  />
                </Col>
              </Row>

              <Card className="border-0 rounded-4 mt-3" style={{ background: "rgba(255,255,255,.55)" }}>
                <Card.Body className="p-4">
                  
                  {/* MAMNUAL-EDIT 01  */}
                  <h5 className="mb-2" style={{ color: contactTheme.textColor }}>
                    Start getting results today 
                  </h5>
                  <div className="mb-3" style={{ color: contactTheme.mutedTextColor }}>
                    {PAGE_CONTENT.contact.rightBody}
                  </div>
                  {
                  /* <Button
                    variant="primary"
                    className="rounded-pill px-4"
                    onClick={() => scrollToId(sectionId.features)}
                  >
                    See feature highlights
                  </Button> */
                  }
                </Card.Body>
              </Card>
            </Col>
          </Row>


              
          <LiveAgent365Footer_v02 brandName={String(brand.name)} version={VERSION} />
        </Container>
      </Section>
    </div>
  );
}










export function LiveAgent365Router_v02_2026_02_16_chat() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LiveAgent365Page_v02_v3g_A2P />} />
        <Route path="/privacy" element={<LiveAgent365PrivacyPolicyPage_v02 />} />
        <Route path="/terms" element={<LiveAgent365TermsOfServicePage_v02 />} />
        <Route path="/contact" element={<ContactPage_v03a />} />
      </Routes>
    </BrowserRouter>
  );
}

export default LiveAgent365Router_v02_2026_02_16_chat;

